import React, { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'
import { USERS } from '../../../graphql/queries'

const style = {
  width: '100%',
}

const UsersFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { data: { users = {} } = {}, loading: isLoadingUsers } = useQuery(
    USERS,
    {
      fetchPolicy: 'no-cache',
    },
  )

  const options = useMemo(
    () =>
      map(users, ({ name, id }) => ({
        name,
        value: Number(id),
      })),
    [users],
  )

  const { userIds } = getQueryParams(search)

  const handleChange = useCallback(
    userIds =>
      history.push(
        createUrl(pathname, search, {
          userIds,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Users" labelCol={{ span: 24 }}>
      <Select
        style={style}
        allowClear
        loading={isLoadingUsers}
        value={userIds}
        mode="multiple"
        onChange={handleChange}
        maxTagCount={5}
        maxTagPlaceholder={omittedValues =>
          `and ${omittedValues.length} more...`
        }
      >
        {map(options, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default UsersFilter
